import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class SEO extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get title() {
    return get(this, '_meta_tags__meta_title.value');
  }

  get description() {
    return get(this, '_meta_tags__meta_description.value');
  }

  get ogImage() {
    return get(this, '_meta_tags__meta_image.value[0].url');
  }

  get ogType() {
    return get(this, '_meta_tags__meta_type.value[0].name');
  }

  get noIndex() {
    return get(this, '_meta_tags__meta_noindex.value');
  }

  get model() {
    return {
      title: this.title,
      description: this.description,
      ogImage: this.ogImage,
      ogType: this.ogType,
      noIndex: this.noIndex
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/SEO.model.js